// BookingContext.js
import React, { createContext, useContext, useReducer, useEffect } from 'react';
import api from '../utils/axios';
import { useAuth } from './AuthContext';

const BookingContext = createContext();

const initialState = {
  bookings: [],
  totalPages: 1,
  page: 1,
  filters: {
    requester: '',
    status: '',
    office: '',
    vehicle: '',
  },
  users: [],
  vehicles: [],
  loading: false,
  usersLoading: true,
  vehiclesLoading: true,
  error: null,
};


function bookingReducer(state, action) {
  switch (action.type) {
    case 'SET_BOOKINGS':
      return { ...state, bookings: action.payload.bookings, totalPages: action.payload.totalPages };
    case 'SET_PAGE':
      return { ...state, page: action.payload };
    case 'SET_FILTERS':
      return { ...state, filters: { ...state.filters, ...action.payload } };
    case 'SET_USERS':
      return { ...state, users: action.payload, usersLoading: false };
    case 'SET_VEHICLES':
      return { ...state, vehicles: action.payload, vehiclesLoading: false };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_ERROR':
      return { ...state, error: action.payload };
    default:
      return state;
  }
}

export const BookingProvider = ({ children }) => {
  const [state, dispatch] = useReducer(bookingReducer, initialState);
  const { user, token } = useAuth();
  
  useEffect(() => {
      const fetchBookings = async () => {
        dispatch({ type: 'SET_LOADING', payload: true });
        if (!token || !user) return;
        try {
          const token = localStorage.getItem('token');
          const queryParams = new URLSearchParams({
            ...state.filters,
            page: state.page,
          });
          const [bookingRes, userRes, vehicleRes] = await Promise.all([
            api.get(`/api/car-bookings?${queryParams.toString()}`, { headers: { Authorization: `Bearer ${token}` } }),
            api.get(`/api/users`, { headers: { Authorization: `Bearer ${token}` } }),
            api.get(`/api/vehicles`, { headers: { Authorization: `Bearer ${token}` } }),
          ]);
    
          dispatch({ type: 'SET_BOOKINGS', payload: { bookings: bookingRes.data.bookings, totalPages: bookingRes.data.totalPages } });
          dispatch({ type: 'SET_USERS', payload: userRes.data });
          dispatch({ type: 'SET_VEHICLES', payload: vehicleRes.data });
        } catch (err) {
          console.error('Fetch error:', err);
          dispatch({ type: 'SET_ERROR', payload: err.message });
        } finally {
          dispatch({ type: 'SET_LOADING', payload: false });
        }
      };
    fetchBookings();
  }, [state.page, state.filters, token, user]);

  return (
    <BookingContext.Provider value={{ state, dispatch }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBookingContext = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBookingContext must be used within a BookingProvider');
  }
  return context;
};
